export default {
  conversation: null,
  visible: false,
  eventId: null,
  eventDescription: '',
  conversationVersion: 0,
  imagePolicyConfirmed: false,
  attachmentUrls: {}
}
